// Default counterparty model for eval cases.
// The eval case stores `provider` + `model` as free text; relay forwards both
// straight to VAPI with NO validation, so an unknown pair only fails when a run
// executes (and the provider's key must be configured in VAPI).

export interface EvalCounterpartyModel {
  provider: string
  model: string
}

export const DEFAULT_EVAL_MODEL: EvalCounterpartyModel = {
  provider: 'openai',
  model: 'gpt-4o',
}
